import { render, staticRenderFns } from "./arrivalCell.vue?vue&type=template&id=393f671a&"
import script from "./arrivalCell.vue?vue&type=script&lang=js&"
export * from "./arrivalCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports